module.exports = __webpack_public_path__ + "static/card-mockup-97741e2d7dc72b7336d728252ed05895.png";